import React from 'react';
import { Recipe } from '../../../models/Recipe';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { CardRecipeV2 } from '../../ModalRecipesV2/CardRecipeV2/CardRecipeV2';
import { CardCustomerRecipe } from '../../ModalRecipesV2/CardCustomerRecipe/CardCustomerRecipe';
import { Container, RecipeGroup } from './styles';

interface ITabRecipesProps {
  recipes?: Recipe[];
  customerRecipes?: CustomerRecipe[];
}

export const TabRecipes: React.FC<ITabRecipesProps> = ({
  recipes,
  customerRecipes
}) => {

  return (
    <Container>
      {recipes && recipes?.length > 0 && (
        <RecipeGroup>
          {recipes?.map(recipe => {
            return <CardRecipeV2 key={`recipe-${recipe.id}`} recipe={recipe} showExpanded={true} readonly={true} />
          })}
        </RecipeGroup>
      )}
      {customerRecipes && customerRecipes?.length > 0 && (
        <RecipeGroup>
          {customerRecipes?.map(recipe => {
            return <CardCustomerRecipe key={`recipe-${recipe.id}`} recipe={recipe} showExpanded={true} readonly={true} />
          })}
        </RecipeGroup>
      )}
    </Container>
  )
};
